import { render } from "./Projects.vue?vue&type=template&id=790d16ad&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=790d16ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-790d16ad"

export default script